// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions[data-v-06abfada]{grid-gap:10px;display:flex}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Products/ProductPackages/Index.vue"],"names":[],"mappings":"AACA,0BAEI,aAAA,CADA,YACA","sourcesContent":["\n.actions {\n    display: flex;\n    grid-gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
